/**
 * Public bounty API client wrapping the backend /bounties endpoint.
 * Fetches paginated bounty listings with optional category, sex,
 * categoryType, and status filters (PublicBountyQueryParams).
 * Consumed by ItemCollection to render public bounty feeds.
 */
import { Bounty } from "@/types/bounty";
import { Category, Sex } from "@/types/category";
import { BountyStatus } from "@/types/bounty";
import { PaginatedResponse } from "@/types/pagination";
import { fetchPaginatedItems } from "@/api/paginated";

export interface PublicBountyQueryParams {
    page?: number;
    perPage?: number;
    category?: Category | null;
    sex?: Sex | null;
    categoryType?: string | null;
    status?: BountyStatus;
}

export const BountyAPI = {
    fetchBounties: async (
        params: PublicBountyQueryParams = {}
    ): Promise<PaginatedResponse<Bounty>> => {
        return fetchPaginatedItems<Bounty>("/bounties", params);
    },
};
